import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {change, Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {filterStyles} from '../shared/styles-filter';
import VirtualizedSelectInput from './VirtualizedSelectInput';
import {assembleSelectOptionsFromConfigData} from '../shared/reportJobFunctions';

/**
 * A form containing SelectInput components with Category and Report choices based on configuration
 *
 */
class ReportJobsFilterCategoryReport extends Component {
    constructor(props) {
        super(props);
        const choicesCategory = assembleSelectOptionsFromConfigData('category', props.configData);
        this.state = {
            choicesCategory: choicesCategory,
            choicesReport: [],
        };
        this.handleReportTypeFilterChange = this.handleReportTypeFilterChange.bind(this);
    }

    handleCategorySelect = (event, index, value) => {
        let choicesReport = [];
        let selectedCategory = '';
        if (index) {
            selectedCategory = index;
            choicesReport = assembleSelectOptionsFromConfigData('executors', this.props.configData[index].executors);
        } else {

        }
        this.setState({
            choicesReport: choicesReport,
        }, () => {
            this.props.dispatch(change('reportJobFilterForm', 'report_job_filter_report_category', selectedCategory));
            if (typeof this.props.onFilterChange === 'function') {
                this.props.onFilterChange({type: 'report-category', value: selectedCategory});
            }
        });
    };

    handleReportSelect = (event, index, value) => {
        this.props.dispatch(change('reportJobFilterForm', 'report_job_filter_report_type', index));
        if (typeof this.props.onFilterChange === 'function') {
            this.props.onFilterChange({type: 'report-type', value: index});
        }
    };

    handleReportTypeFilterChange(event, index, value) {
        const reportTypeValue = (index && index !== value) ? index : '';
        this.setState({
            reportTypeId: reportTypeValue
        }, () => {
            this.props.dispatch(change('reportJobFilterForm', 'report_job_filter_report_type', this.state.reportTypeId));
            if (typeof this.props.onFilterChange === 'function') {
                this.props.onFilterChange({type: 'report-type', value: this.state.reportTypeId});
            }
        });
    }

    render() {
        const {clearable, instructions} = this.props;
        const {choicesCategory, choicesReport} = this.state;

        const styles = {
            instructions: {fontSize: 12, margin: '1em 0 -1em 0'}
        };

        return (
            <div style={filterStyles.reportFilterContainer}>
                {instructions &&
                    <div style={styles.instructions}>
                        If desired, filter by Report Category and Report.
                    </div>
                }
                <div style={filterStyles.filterContainerInline}>
                    <Field name="filter_report_job_report_category"
                           component={VirtualizedSelectInput}
                           choices={choicesCategory}
                           label="Filter by Category"
                           optionValue="id"
                           allowEmpty
                           options={{
                               clearable: clearable,
                               className: 'inline medium',
                               label: 'Filter by Category',
                               placeholder: 'Filter by Category'
                           }}
                           onChange={this.handleCategorySelect}
                    />
                    <Field name="filter_report_job_report_type"
                           component={VirtualizedSelectInput}
                           choices={choicesReport}
                           label="Filter by Report"
                           optionValue="id"
                           allowEmpty
                           options={{
                               clearable: clearable,
                               className: 'inline medium',
                               label: 'Filter by Report',
                               placeholder: 'Filter by Report'
                           }}
                           onChange={this.handleReportSelect}
                    />
                </div>
            </div>
        );
    }
}

ReportJobsFilterCategoryReport.propTypes = {
    configData: PropTypes.object,
    addField: PropTypes.bool,
    clearable: PropTypes.bool,
    fullWidth: PropTypes.bool,
    instructions: PropTypes.bool,
    onFilterChange: PropTypes.func
};

ReportJobsFilterCategoryReport.defaultProps = {
    configData: {},
    addField: true,
    clearable: true,
    fullWidth: false,
    instructions: false
};

const enhance = compose(
    connect(),
    reduxForm({
        form: 'reportJobFilterForm',
        enableReinitialize: true
    })
);

export default enhance(ReportJobsFilterCategoryReport);



// WEBPACK FOOTER //
// ./src/Fuse/components/ReportJobsFilterCategoryReport.js